import { QueryClient } from "@tanstack/react-query";
import { notification } from "antd";

/**
 * Centralized TanStack Query client configuration.
 *
 * Defaults:
 * - staleTime: 5 minutes — data is considered fresh for 5 min,
 *   reducing redundant network requests across navigations.
 * - retry: 1 — a single retry on failure to be resilient against
 *   transient network errors without hammering the server.
 * - refetchOnWindowFocus: false — prevents unexpected refetches when
 *   the user alt-tabs back. Enable per-query where real-time data matters.
 *
 * Mutations:
 * - onError: Global fallback that shows a notification when any mutation
 *   fails without its own error handler. Individual mutation hooks can
 *   still override this with their own onError callback.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      onError: (error) => {
        const message =
          error?.response?.data?.detail ?? error?.message ?? "An unexpected error occurred.";

        notification.error({
          message: "Operation Failed",
          description: message,
          duration: 5,
        });
      },
    },
  },
});

export default queryClient;
